<template>
  <form class="box" @input='calculate'>
    <div class="value">
      <span>موجودی تومانی</span>
      <span class="number" style="cursor: pointer">
        تومان {{ $toLocal(cash, $decimal["TOMAN"]) }}</span
      >
    </div>

    <!-- Market section -->

    <div v-if="select === 'price'" class="best-of-price-trade">
      <div class="right">
        <span class="trade-price">قیمت خرید</span>
        <span class="best-price">بهترین قیمت بازار</span>
      </div>
      <div class="left">
        <span class="price">
                  <input class="unitprice" type="text"
                         v-model="unitPrice"
                         :disabled="select ==='price'"
                  />
          <!--
                    {{
                      $toLocal( unitPrice, $route.params.tradeTo == 'TOMAN' ? $decimal['TOMAN'] : $decimal['TETHER'])
                    }} -->
          
          
          </span>
        <inline-svg :src="require('@/assets/coins/TOMAN.svg')" v-if="$route.params.tradeTo =='TOMAN'"/>
        <inline-svg :src="require('@/assets/coins/USDT.svg')" v-else/>
      </div>
    </div>
    <div class="input" v-if="select === 'price'">
      <span class="placeholder"> حجم خرید </span>
      <div class="text-input">
        <input
            type="text"
            class="inp-text"
            @input="amount = $toLocal(amount, $decimal[tradeFrom])"
            v-model="amount"
            :id="'amount' + id"
        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>

    <!--        market section ended-->

    <!--Limit-order-->
    <div

        class="input"
        v-if="select === 'limit'"
    >
      <span
          :style="{color:danger==true? 'red' :''}"
          class="placeholder"
      >
        {{ danger == true ? 'ابتدا قیمت خرید را وارد کنید' : 'حد خرید قیمت' }}
      </span>
      <div class="text-input">
        <input

            type="text"
            class="inp-text"
            v-model="unitPrice"
            @input="unitPrice = $toLocal(unitPrice, $decimal[tradeFrom])"


        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>

    <div

        class="input"
        v-if="select === 'limit'"
    >
      <span

          class="placeholder"
      >
        حجم خرید
      </span>
      <div class="text-input">
        <input

            type="text"
            class="inp-text"
            v-model="amount"
            :id="'limit' + id"
        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>
    <date-picker v-if="select === 'limit'"
                 placeholder="تاریخ انقضا"
                 :format="$dateFormat['en']"
                 :display-format="$dateFormat['faDateTime']"
                 :max="$jmoment().format($dateFormat['en'])"
                 type="datetime"
                 v-model='eDate'

    />
    <!--limit orders ended-->

    <!-- Stop-limit -->
    <div v-if="select === 'Stop-Limit'" class="input">
      <span
          :style="{color:danger==true? 'red' :''}"
          class="placeholder"
      >
        {{ danger == true ? 'ابتدا قیمت خرید را وارد کنید' : 'حد خرید قیمت' }}
      </span>
      <div class="text-input">
        <input

            type="text"
            class="inp-text"
            v-model="unitPrice"
            @input="unitPrice = $toLocal(unitPrice, $decimal[tradeFrom])"


        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>

    <div

        class="input"
        v-if="select === 'Stop-Limit'"
    >
      <span

          class="placeholder"
      >
       حد توقف
      </span>
      <div class="text-input">
        <input
            v-model="stopPrice"
            type="text"
            class="inp-text"
        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>


    <div

        class="input"
        v-if="select === 'Stop-Limit'"
    >
      <span

          class="placeholder"
      >
        حجم خرید
      </span>
      <div class="text-input">
        <input

            type="text"
            class="inp-text"
            v-model="amount"
            :id="'limit' + id"
        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>
    <date-picker v-if="select === 'Stop-Limit'"
                 placeholder="تاریخ انقضا"
                 :format="$dateFormat['en']"
                 :display-format="$dateFormat['faDateTime']"
                 :max="$jmoment().format($dateFormat['en'])"
                 v-model="eDate"
                 type="datetime"
    />

    <!--stop-limit ended-->

    <!-- OCO-->
    <!--        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='کف قیمت خرید'/>-->
    <!--        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='سقف قیمت خرید'/>-->
    <!--        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='سفارش خرید در قیمت'/>-->
    <!--        <custom-buy-input v-if="select === 'OCO'" :data="selectCoin" placeholder='حجم خرید'/>-->

    <div v-if="select === 'OCO'" class="input">
      <span
          :style="{color:danger==true? 'red' :''}"
          class="placeholder"
      >
        {{ danger == true ? 'ابتدا قیمت خرید را وارد کنید' : 'حد خرید قیمت' }}
      </span>
      <div class="text-input">
        <input

            type="text"
            class="inp-text"
            v-model="unitPrice"
            @input="unitPrice = $toLocal(unitPrice, $decimal[tradeFrom])"


        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>

    <div

        class="input"
        v-if="select === 'OCO'"
    >
      <span

          class="placeholder"
      >
       حد توقف
      </span>
      <div class="text-input">
        <input
            v-model="stopPrice"
            type="text"
            class="inp-text"
        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>


    <div

        class="input"
        v-if="select === 'OCO'"
    >
      <span

          class="placeholder"
      >
        حجم خرید
      </span>
      <div class="text-input">
        <input

            type="text"
            class="inp-text"
            v-model="amount"
            :id="'limit' + id"
        />
        <inline-svg
            :src="require('@/assets/coins/' + state.marketType + '.svg')"
        />
      </div>
    </div>
    <date-picker v-if="select === 'OCO'"
                 placeholder="تاریخ انقضا"
                 :format="$dateFormat['en']"
                 :display-format="$dateFormat['faDateTime']"
                 :max="$jmoment().format($dateFormat['en'])"
                 v-model="eDate"
                 type="datetime"/>

    <!--range input type -->
    <div class="range">
      <inputRange @change="putcash"/>
    </div>
    <div class="text-rang">
      <span>کارمزد : {{ state.userInfo.fee }}%</span>
      <span>مقدار :{{ $toLocal(percent * 100, 2) }}%</span>
    </div>
    <!--        دریافتی شما -->
    <div class="resive">
      <span>دریافتی شما</span>
      <div class="input less-border">
        <span class="resive-value number">
          
          {{
            totalPrice
          }}
        </span>
        <img
            v-if="$route.params.tradeTo =='TOMAN'"
            :src="require('@/assets/coins/TOMAN.svg')"
            alt=""
        />
        <img
            v-else
            :src="require('@/assets/coins/TETHER.svg')"
            alt=""
        />
      </div>
    </div>
    <!--        buttons -->

    <button class="buyBtn" @click.prevent="buy = true" :disabled="!!readonly">


      {{
        readonly ? readonly : 'ثبت خرید'
      }}
    </button>
    <buyModal v-if="buy === true" @close="buy = false" :unitPrice="unitPrice" :totalPrice="totalPrice" :amount="amount"
              :limit='select' :type="`BUY`" :stopPrice="stopPrice"/>
  </form>
</template>
<script>
import buyModal from "../buyModal.vue";
import inputRange from "./inputRange.vue";
import '@/styles/dateTimePicker.scss';
import {
  tradeTo,
  tradeFrom,
  precision,
  Loop,
} from "@/lib/reuseableFunction";

export default {
  components: {
    inputRange,
    buyModal,
  },
  name: "buyMenu",
  props: ["cash", "data", "select", "role", "decimal", "id"],
  data() {
    return {
      focusebuy: false,
      amount: 0,
      totalValue: 0,
      amountsell: 0,
      totalValuesell: 0,
      resiveValue: 0,
      buy: false,
      label: null,
      label2: null,
      SuccessSell: false,
      thisModal: true,
      //  min:54654654654,
      fee: 0.4,
      date_disable: true,
      stopPrice: 0,
      eDate: "",
      percent: 0,
      unitPrice: "",
      totalPrice: 0,
      danger: false,
      danger1: false,
      danger2: false,
      show: false,
      value: "",
      checked: "",
      calculating: false,
      getAmount: false,
      amountTemp: "",
      count: 0,
      alive: true,
      loop: undefined,
      coins: "",
      priceError: "",
      amountError: "",
      minAmountOrder: null,
      maxAmountOrder: null,
      disableBuyBtn: true,
      rangeValue: 0,
    };
  },
  methods: {
//input range value


    //input range value
    async putcash(p) {

      if (this.select === 'limit') {
        let up = this.$S2N(this.unitPrice)

        if (up) {
          this.percent = p
          let e = (this.percent * this.cash) / up
          this.amount = this.$toLocal(e, this.decimal)
          this.calculate()
          this.danger = false
        } else if (!this.amount) {
          this.danger = true
        } else {
          this.danger = false
        }
      }
      if (this.select === 'price') {
        this.percent = p
        console.log(p)
        let e = this.percent * this.cash
        if (e) {
          this.getAmount = true
          const res = await this.$http('/orders/amount-via-price?marketType=' + this.tradeFrom + '_' + this.tradeTo + '&orderType=MARKET_BUY&amount=' + e, {
            // params: {
            //     marketType: this.tradeFrom + '_' + this.tradeTo,
            //     orderType: 'MARKET_BUY',
            //     amount: e
            // }
          })

          this.getAmount = false
          if (res) {
            // console.log('resssssssss',res);
            this.amount = this.$toLocal(res[0].baseDTO.wholePrice, this.decimal)
            this.calculate()
          }
        }
      }

    },
    setMin() {
      if (this.select === 'limit') {
        this.unitPrice = this.$toLocal(
            this.state.shopInfo.minSell,
            this.tradeTo === "TOMAN" ? 0 : this.$decimal[this.tradeFrom]
        );
        this.danger = false;
        this.calculate();
      }
    },
    localCalculate() {
      const up = this.$S2N(this.unitPrice);
      const a = this.$S2N(this.amount);
      this.totalPrice = this.$toLocal(up * a, this.$decimal[this.tradeTo]);
      if (this.cash == 0) {
        this.percent = 0;
      } else this.percent = this.$S2N(this.totalPrice) / this.$S2N(this.cash);
    },
    async serverCalculate() {
      this.loop ? this.loop.stop() : "";
      this.calculating = true;
      const a = this.amount;
      await this.$sleep(500);
      if (a === this.amount) {
        this.loop = new Loop(
            this.getPriceFromServer,
            this.state.time,
            "getPriceBuy"
        );
        this.loop.start();
      }
    },
    async getPriceFromServer() {

      let amount = this.$S2N(this.amount);
      // console.log(amount)
      const [res] = await this.$http.get("/orders/market-buy-sell-whole", {
        params: {
          amount: amount,
          marketType: this.tradeFrom + "_" + this.tradeTo,
          orderType: "MARKET_BUY",
        },
      });
      if (res) {
        // console.log('response server',res)
        this.totalPrice = this.$toLocal(
            res.baseDTO.wholePrice,
            this.precision
        );
        // let totalPrice = this.$S2N(this.totalPrice)
        // console.log('totalprice',totalPrice / amount)
        this.unitPrice = this.$toLocal(
            this.$S2N(this.totalPrice) / amount,
            this.precision
            // this.tradeTo === "TOMAN" ? 0 : this.$prcision[this.tradeFrom]
        );
        this.percent = this.$S2N(this.totalPrice) / this.cash;
      }
      this.calculating = false;

      // console.log('amount',amount)
    },
    async getAmountFromServer(p) {
      this.percent = p || this.percent;
      let e = this.percent * this.cash;
      if (e) {
        this.getAmount = true;
        const res = await this.$http("/orders/amount-via-price", {
          params: {
            marketType: this.tradeFrom + "_" + this.tradeTo,
            orderType: "MARKET_BUY",
            amount: e,
          },
        });
        this.getAmount = false;
        if (res) {
          this.amount = this.$toLocal(res.baseDTO.wholePrice, this.decimal);
          this.calculate();
        }
      }
    },
    calculate() {
      console.log(this.amount)
      if (this.select === 'limit' && this.unitPrice && this.amount) {
        this.localCalculate();
      } else if (this.select === 'Stop-Limit' && this.unitPrice && this.amount) {
        this.localCalculate();
      } else if (this.select === 'OCO' && this.unitPrice && this.amount) {
        this.localCalculate();
      } else if (this.select === 'price' && this.$S2N(this.amount)) {
        this.serverCalculate();
      }
    },
    // showmodal() {
    //   if (!(!this.limit || this.$S2N(this.unitPrice))) {
    //     this.danger = true;
    //     this.danger1 = false;
    //     this.danger2 = false;
    //   } else if (!this.$S2N(this.amount)) {
    //     this.danger1 = true;
    //     this.danger2 = false;
    //     this.danger = false;
    //   } else if (
    //     (this.$S2N(this.totalprice) > this.$S2N(this.cash) ||
    //       this.$S2N(this.totalprice)) &&
    //     !this.state.userInfo.supervisor
    //   ) {
    //     this.danger2 = true;
    //     this.danger1 = false;
    //     this.danger = false;
    //   } else {
    //     this.show = true;
    //     this.danger = false;
    //     this.danger1 = false;
    //     this.danger2 = false;
    //   }
    // },
    async getCoins() {
      this.state.loading = true;
      const res = await this.$axios.get("/coins/details");
      this.coins = res.content;
      this.minAmountOrder = this.coins.find(
          (a) => a.coin == this.tradeFrom
      ).minAmount;
      this.maxAmountOrder = this.coins.find(
          (a) => a.coin == this.tradeFrom
      ).maxAmount;
    },

    //function that changes range in the label
  },

  mounted() {
    this.label = 0.5;
    this.label2 = 0.5;
    this.getCoins();
  },
  computed: {


    tradeTo,
    tradeFrom,
    precision,


    now() {
      return this.$jmoment().add(5, "minute").format(this.$dateFormat["en"]);
    },
    readonly() {
      // console.log('up',this.unitPrice)
      // console.log('amount', this.amount)
      let priceError = "";
      // if (this.limit && !this.$S2N(this.unitPrice)) {
      //   priceError = "قیمت واحد اجباریست";
      // }


      if (!this.$S2N(this.amount)) {
        priceError = "مقدار ارز اجباریست";
      } else if (this.$S2N(this.amount) < this.min) {
        priceError = "مقدار ارز کمتر از حد مجاز است";
      } else if (this.$S2N(this.amount) > this.max) {
        priceError = "مقدار ارز بیشتر از حد مجاز است";
      } else if (
          this.$S2N(this.totalPrice) > this.$S2N(this.cash) &&
          !this.state.userInfo.supervisor
      ) {
        priceError = "موجودی کافی نیست";
      }
          // else if (
          //  !this.limit && !this.$S2N(this.unitPrice)
          // ) {
          //   priceError = "مقدار مورد نظر مجاز نیست";
          // }
          // else if (this.load) {
          //     priceError = 'لطفا صبر کنید...'
      // }
      else if (!this.select == 'limit' && this.state.userInfo.supervisor) {
        priceError = "بازارگردان قادر به انجام سفارش بازار نیست";
      }
      return priceError;
    },

    load() {
      return this.calculating || this.getAmount;
    },
    min() {
      return this.role.minAmount;
    },
    max() {
      return this.role.maxAmount;
    },
    range() {
      return (
          "حداقل " +
          this.$toLocal(this.min) +
          " " +
          this.$coins[this.tradeFrom].persianName +
          "\n" +
          "حداکثر " +
          this.$toLocal(this.max) +
          " " +
          this.$coinLabel[this.tradeFrom]
      );
    },
  },
  watch: {

    "state.buyAmount"() {
      this.amount = this.$toLocal(this.state.buyAmount, this.decimal);
      this.unitPrice = this.$toLocal(
          this.state.buyPrice,
          this.tradeTo === "TOMAN" ? 0 : this.$prcision[this.tradeFrom]
      );
      this.calculate();
    },
    "state.buyPrice"() {
      this.amount = this.$toLocal(this.state.buyAmount, this.decimal);
      this.unitPrice = this.$toLocal(
          this.state.buyPrice,
          this.tradeTo === "TOMAN" ? 0 : this.$prcision[this.tradeFrom]
      );
      this.calculate();
    },
  },
};
</script>

<style lang="scss" scoped>
//public class
.less-border {
  border: none !important;
}

.gray-btn {
  background: rgba(215, 200, 200, 0.12) !important;
  border-radius: 4px !important;
  color: rgba(17, 153, 250, 1) !important;
  cursor: pointer !important;
  font-size: clamp(10px, 2vw, 12px) !important;
  height: auto;
  width: auto;
}

.buyBtn {
  width: 100%;
  height: 36px;
  background: #04b3a2;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  position: absolute;
  bottom: 0;

  &:hover {
    background: linear-gradient(
            180deg,
            #03dac5 0%,
            rgba(140, 166, 142, 0) 425%
    );
  }
}

.sellBtn {
  width: 100%;
  height: 36px;
  background: #d94f68;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  position: absolute;
  bottom: 0;

  &:hover {
    background: linear-gradient(
            180deg,
            #d94f68 0%,
            rgba(255, 60, 95, 0) 355.56%
    );
  }
}

.main-buy-and-sell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  direction: rtl;

  .buttons {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    button {
      width: 150px;
      height: 25px;
    }
  }

  .range {
    display: flex;
    width: 100%;
    height: 20px;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    bottom: 130px;
  }

  .text-rang {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 10px;
    color: rgba(215, 200, 200, 1);
    position: absolute;
    bottom: 100px;
  }

  .resive {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px;
    border: 1px solid #8c8585;
    box-sizing: border-box;
    border-radius: 4px;
    align-items: center;
    width: 100%;
    height: 36px;
    position: absolute;
    bottom: 50px;

    span {
      color: rgba(140, 133, 133, 1);
      font-size: 12px;
    }

    .input {
      display: flex;
      align-items: center;

      .resive-value {
        font-size: 14px;
        color: #ffffff;
        margin-left: 10px;
      }
    }
  }

  .buy-and-sell {
    display: flex;
    flex-direction: row;
    background: linear-gradient(
            180deg,
            rgba(140, 133, 133, 0.12) 0%,
            rgba(215, 200, 200, 0.0408) 100%
    );
    border-radius: 4px;
    min-height: 370px;
    gap: 20px;
    padding: 14px;
    flex-wrap: wrap;

    .box {
      display: flex;
      flex-grow: 1;
      flex-basis: 100px;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 16px;
      position: relative;

      .value {
        font-size: 10px;
        color: rgba(215, 200, 200, 1);
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 20px;
        direction: rtl;
      }

      .best-of-price-trade {

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 36px;
        background: rgba(215, 200, 200, 0.12);
        border: 0.75px solid #8c8585;
        border-radius: 4px;
        margin-top: -10px;

        svg {
          margin-left: 6px;
        }

        .right {
          display: flex;
          flex-direction: column;
          text-align: right;
          flex-grow: 1;
          justify-content: start;
          margin-right: 6px;

          .trade-price {
            font-size: 10px;
            color: #1199fa;
          }

          .best-price {
            font-size: clamp(.3em, 1vw, .6rem);
            color: #ffffff;
          }
        }

        .left {
          display: flex;
          flex-grow: 1;

          align-items: center;
          justify-content: end;
          gap: 5px;

          .price {
            font-size: 12px;
            font-weight: bold;
          }
        }
      }

      .stop {
        @extend .best-of-price-trade;
        background: none !important;
      }
    }
  }
}

@media (max-width: 992px) {
  .buttons {
    gap: 10px !important;
  }
  .buttons button {
    width: auto !important;
  }

  .change-type {
    justify-content: space-between !important;
  }
}

@media (max-width: 500px) {
  .buy-and-sell {
    flex-direction: column !important;
    gap: 40px;
    min-height: 770px !important;
  }

  .box {
    gap: 10px;
  }

  .text-rang {
    margin-top: 10px;
  }
}

@media (max-width: 380px) {
  .main-trade {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>


.unitprice {
  direction: ltr;
  color: white;
}

.focusebuy {
  font-size: 10px !important;
  color: rgba(17, 153, 250, 1) !important;
  position: absolute;
  top: 3px !important;
}

.activebuy {
  border: 1px solid #ffffff !important;
}

.unfocusebuy {
  color: rgba(115, 109, 109, 1) !important;
  font-size: 12px !important;
}

.input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #736d6d;
  box-sizing: border-box;
  border-radius: 4px;
  height: 36px;
  width: 100%;
  padding: 8px;
  position: relative;

  > span {
    transition: top 0.3s, font-size 0.3s;
  }

  &:hover {
    border: 1px solid rgba(251, 251, 253, 1) !important;
  }

  &:hover .placeholder {
    color: rgba(215, 200, 200, 1);
  }

  .placeholder {
    color: rgba(115, 109, 109, 1);
    font-size: 12px;
    position: absolute;
    top: 25%;
  }

  .text-input {
    display: flex;
    flex-direction: row;
    gap: 5px;
    left: 5px;
    position: absolute;

    .inp-text {
      font-size: 12px;
      font-weight: bold;
      color: #ffffff;
      text-align: left;
    }
  }

  .inp-text:hover .placeholder {
    color: #1199fa !important;
  }
}
</style>
<style lang="scss">
.vpd-input-group input {
  flex-grow: 1;
  border: 1px solid rgba(218, 218, 218, 0.38) !important;
  border-right: none !important;
  border-radius: 4px 0 0 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  line-height: 30px;
  padding: 0 10px;
}
.vpd-icon-btn {
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  border-radius: 0 4px 4px 0;
  justify-content: center;

  align-items: center;
}

</style>